/**
 * @generated SignedSource<<919d8c942398b7a9d602dc89d8b2f52b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateFromListRowFragment$data = {
  readonly completeLiquidRepresentation: ReadonlyArray<{
    readonly lots: ReadonlyArray<{
      readonly rules: {
        readonly " $fragmentSpreads": FragmentRefs<"LiquidDelegationRulesFragment">;
      };
    }>;
    readonly owner: {
      readonly address: {
        readonly resolvedName: {
          readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
        };
      };
    };
    readonly proxy: {
      readonly nounsRepresented: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounImageFragment">;
      }>;
    };
  }>;
  readonly tokenHoldersRepresented: ReadonlyArray<{
    readonly address: {
      readonly resolvedName: {
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
      };
    };
    readonly nounsOwned: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"NounImageFragment">;
    }>;
    readonly tokensOwned: {
      readonly amount: {
        readonly amount: string;
      };
    };
  }>;
  readonly " $fragmentType": "DelegateFromListRowFragment";
};
export type DelegateFromListRowFragment$key = {
  readonly " $data"?: DelegateFromListRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateFromListRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ResolvedName",
      "kind": "LinkedField",
      "name": "resolvedName",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NounResolvedLinkFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "NounImageFragment"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegateFromListRowFragment",
  "selections": [
    {
      "alias": "completeLiquidRepresentation",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {}
        }
      ],
      "concreteType": "LiquidDelegationRepresentation",
      "kind": "LinkedField",
      "name": "liquidRepresentation",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Delegate",
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Delegate",
          "kind": "LinkedField",
          "name": "proxy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Noun",
              "kind": "LinkedField",
              "name": "nounsRepresented",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiquidDelegationLot",
          "kind": "LinkedField",
          "name": "lots",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LiquidDelegationRules",
              "kind": "LinkedField",
              "name": "rules",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "LiquidDelegationRulesFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "liquidRepresentation(filter:{})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "tokenHoldersRepresented",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VotingPower",
          "kind": "LinkedField",
          "name": "tokensOwned",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TokenAmount",
              "kind": "LinkedField",
              "name": "amount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Noun",
          "kind": "LinkedField",
          "name": "nounsOwned",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};
})();

(node as any).hash = "877dc5a5d23fe98c0b1b3b659a1af651";

export default node;
